import React from "react";

export default function CommonLoader({ text = "Loading..." }) {
  return (
    <div className="app-loader">
      <div className="app-loader__panel">
        <div className="app-loader__ring" aria-hidden="true">
          <div className="app-loader__ring-core"></div>
        </div>
        <div className="app-loader__text">{text}</div>
        <div className="app-loader__dots" aria-hidden="true">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  );
}
